import PageBreadcrumbs from "@/components/PageBreadcrumbs";
import {
  snackMenuItemsOptions,
  snackSupplierOptions,
  useBuilding,
} from "@/api";
import { useWelcomeSnackAccess } from "@/hooks/useWelcomeSnackAccess";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import SnackOrderForm from "@/components/snack/order_form";
import { MultiFieldInvoiceReference, SnackDeliveryMethod } from "@/types";
import ContactDetails from "@/components/snack/ContactDetails";
import { useRouterStore } from "@/store/zustandStore";
import { useBuildingQuery } from "@/components/RouterSetup";

export const Route = createFileRoute("/_portal/orders/new")({
  component: RouteComponent,
  validateSearch: (search: {
    deliveryType?: SnackDeliveryMethod;
    deliveryTime?: Date | string;
    deliveryInstructions?: string;
    preselectedItemId?: string;
    participantsCount?: number;
    invoiceReference?: string | MultiFieldInvoiceReference;
  }) => search,
  loader: () => {
    const { queryClient, supplierCompanyId } = useRouterStore.getState();
    if (!queryClient) return;
    queryClient.prefetchQuery(snackSupplierOptions(supplierCompanyId));
    queryClient.prefetchQuery(snackMenuItemsOptions(supplierCompanyId));
  },
});

function RouteComponent() {
  const { t } = useTranslation();
  const { data: building } = useBuilding();
  const { data: supplier } = useBuildingQuery(
    snackSupplierOptions(building.supplierCompanyId),
  );

  useWelcomeSnackAccess(false, true);

  return (
    <>
      <PageBreadcrumbs
        levels={[{ label: t("SIDEBAR.ORDER"), path: "/orders/new" }]}
      />
      <div className="pageHeader">
        <h1>{t("SIDEBAR.ORDER")}</h1>
        <p>
          {t("PAGES.ORDER_FOOD.SUBHEADER", {
            buildingName: building.displayName,
          })}
          {(supplier?.email || supplier?.phone) && (
            <>
              {" "}
              <ContactDetails supplier={supplier} />
            </>
          )}
        </p>
      </div>
      <SnackOrderForm />
    </>
  );
}
